import { isNil } from 'lodash'
import LogRocket from 'logrocket'

/**
 * Identifies by user by id and email (if present) in LogRocket
 */
export function identifyUser(user: { uid: string; email: string | null }) {
  LogRocket.identify(user.uid, !isNil(user.email) ? { email: user.email } : {})
}
